import { useEffect, useState } from "react";
import CONFIG from '../configuration/config'

export function useBussinesDetails() {
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [controller, setController] = useState(null)

    useEffect(() => {
        let url = CONFIG.URLAB + 'api/app-cms/bussiness-detail/last'
        let token = localStorage.getItem(CONFIG.TOKEN)
        if (!token) {
        //    window.location.href = CONFIG.URLREDIRECT
          // return
        }
        const body = {
            token
        };


        const abortController = new AbortController()
        setController(abortController)
        setLoading(true)
        fetch(url, {
            method: 'POST',
            signal: abortController.signal,
            headers: {
                'Content-Type': 'application/json' // Asegura que el servidor interprete el cuerpo de la solicitud como JSON
            },
            body: JSON.stringify(body)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                console.log('Success:', data);
                if (data.success != true) {
                    localStorage.removeItem(CONFIG.TOKEN)
                 //  window.location.href = CONFIG.URLREDIRECT
                  //  return
                }

                setData(data)
            })
            .catch(error => {
                if (error.name === 'AbortError') {
                    console.log('Fetch aborted');
                } else {
                    console.error('There was a problem with the fetch operation:', error);
                    setError(error)
                }
                setLoading(false)
            })
            .finally(() => setLoading(false));
            return () => abortController.abort();
    }, [])

    const handleCancelRequest = () => {
        if (controller) {
            controller.abort()
            setError("Request Cancelled")
        }

    }

    return { data, loading, error, handleCancelRequest };
}